var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "$";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.', ''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

$(document).ready(function () {

  var imageUrlls = new Array();

  imageUrlls[0] = '//atmohome.com/cdn/shop/files/pets_tomagatchi_cropped_1.png?v=4880';
  imageUrlls[1] = '//atmohome.com/cdn/shop/files/pets_bird_cropped_1.png?v=4880';
  imageUrlls[2] = '//atmohome.com/cdn/shop/files/pets_dog_cropped_1.png?v=4880';
  imageUrlls[3] = '//atmohome.com/cdn/shop/files/pets_cat-dog_cropped_1.png?v=4880';
  imageUrlls[4] = '//atmohome.com/cdn/shop/files/pets_elephant_cropped_1.png?v=4880';


  $(document).on('input change', '#slider_4', function () {//listen to slider changes
    var v6 = $(this).val();//getting slider val
    $('#sliderStatus').html($(this).val());
    $("#img_4").prop("src", imageUrlls[v6]);
    $(this).attr('value', v6);
  });

  var imageUrll = new Array();

  imageUrll[1] = '//atmohome.com/cdn/shop/files/household_1_cropped_1.png?v=4880';
  imageUrll[2] = '//atmohome.com/cdn/shop/files/household_2_cropped_1.png?v=4880';
  imageUrll[3] = '//atmohome.com/cdn/shop/files/household_3_cropped_1.png?v=4880';
  imageUrll[4] = '//atmohome.com/cdn/shop/files/household_4_cropped_1.png?v=4880';
  imageUrll[5] = '//atmohome.com/cdn/shop/files/household_5_cropped_1.png?v=4880';
  imageUrll[6] = '//atmohome.com/cdn/shop/files/household_6_cropped_1.png?v=4880';

  $(document).on('change', '#slider_3', function () {//listen to slider changes
    var v5 = $(this).val();//getting slider val
    $('#sliderStatus').html($(this).val());
    $("#img_3").prop("src", imageUrll[v5]);

    $(this).attr('value', v5);
  });

  var imageUrl = new Array();

  imageUrl[1] = '//atmohome.com/cdn/shop/files/bathroom_1_cropped_1.png?v=4880';
  imageUrl[2] = '//atmohome.com/cdn/shop/files/bathroom_2_cropped_1.png?v=4880';
  imageUrl[3] = '//atmohome.com/cdn/shop/files/bathroom_2_cropped_1.png?v=4880';
  imageUrl[4] = '//atmohome.com/cdn/shop/files/bathroom_3_cropped_1.png?v=4880';
  imageUrl[5] = '//atmohome.com/cdn/shop/files/bathroom_3_cropped_1.png?v=4880';
  imageUrl[6] = '//atmohome.com/cdn/shop/files/bathroom_4_cropped_1.png?v=4880';

  $(document).on('input change', '#slider', function () {//listen to slider changes
    var v = $(this).val();//getting slider val
    $('#sliderStatus').html($(this).val());
    $("#img").prop("src", imageUrl[v]);
    $(this).attr('value', v);
    $("#img").addClass("photo-", v);
  });

  var imageUrls = new Array();

  imageUrls[0] = '//atmohome.com/cdn/shop/files/clean_1_cropped_1.png?v=4880';
  imageUrls[1] = '//atmohome.com/cdn/shop/files/clean_2_cropped_1.png?v=4880';
  imageUrls[2] = '//atmohome.com/cdn/shop/files/clean_3_cropped_1.png?v=4880';

  $(document).on('input change', '#slider_2', function () {//listen to slider changes
    var v2 = $(this).val();//getting slider val
    $('#sliderStatus').html($(this).val());
    $("#img_2").prop("src", imageUrls[v2]);

    $(this).attr('value', v2);
  });

  var imageUrlss = new Array();

  imageUrlss[0] = '//atmohome.com/cdn/shop/files/household_1_cropped.png?v=4880';
  imageUrlss[1] = '//atmohome.com/cdn/shop/files/household_2_cropped.png?v=4880';
  imageUrlss[2] = '//atmohome.com/cdn/shop/files/household_3_cropped.png?v=4880';
  imageUrlss[3] = '//atmohome.com/cdn/shop/files/household_4_cropped.png?v=4880';
  imageUrlss[4] = '//atmohome.com/cdn/shop/files/household_5_cropped.png?v=4880';
  imageUrlss[5] = '//atmohome.com/cdn/shop/files/household_6_cropped.png?v=4880';

  $(document).on('input change', '#slide_3', function () {//listen to slider changes
    var v3 = $(this).val();//getting slider val
    $('#sliderStatus').html($(this).val());
    $("#img_3").prop("src", imageUrlss[v3]);
  });

  window.addEventListener("klaviyoForms", function (e) {
    console.log('Dev' + e.detail.type);
    if (e.detail.type == 'open') {
    }
    if (e.detail.type == 'submit') {
      $(".submit3_btn").fadeIn(100);
      console.log('submitted');
      $('.klaviyo-form').addClass('thankyou-msg');
      window.setTimeout(function () {
//         $("form.needsclick").fadeOut(100);
      }, 1500);
    }
  });

  /*EVENT TRACKING*/
   $(document).on('change', '#slider_3', function (e) {
     var evvalue = $(this).val();
     gtag('event', 'household', {'event_category': 'Calculator', 'event_label': 'click', 'value': evvalue });
 
   });
  $(document).on('change', '#slider_4', function (e) {
     var evvalue = $(this).val();
     gtag('event', 'pets', {'event_category': 'Calculator', 'event_label': 'click', 'value': evvalue });
  
   });
  $(document).on('change', '#slider', function (e) {
     var evvalue = $(this).val();
     gtag('event', 'bathrooms', {'event_category': 'Calculator', 'event_label': 'click', 'value': evvalue });
   
   });
  $(document).on('change', '#slider_2', function (e) {
     var evvalue = $(this).val();
    if(evvalue == 0){
    	var tmp = "Don't-Judge";
    }
    if(evvalue == 1){
    	var tmp = "Pretty-Good";
    }
    if(evvalue == 2){
    	var tmp = "Spotless";
    }
     gtag('event', 'cleaning-style', {'event_category': 'Calculator', 'event_label': 'click', 'value': tmp });
 
   });
  /**********/

  //   Next Screen
  $(document).on('click', '.screen1 .next', function (e) {
    e.preventDefault();
    gtag('event', 'screen', {'event_category': 'Screen', 'event_label': 'click', 'value': "screen 2 visisble" });
    $('.screen1').addClass('hide');
    $('.screen2').removeClass('hide');
  });
  $(document).on('click', '.screen2 .next', function (e) {
    var newsletterInput = document.getElementById('%24consent__4__8');

    if (newsletterInput) {
<!--       newsletterInput.checked = true; -->
    }
    
  var privacyInput = document.getElementById('%24consent__3__7');

  $(privacyInput).on('click', function() {
    var checkbox = $(this);
  
    if (checkbox.is(":checked")) {
      sessionStorage.setItem('privacyPolicy', 'checked')
    } else {
      sessionStorage.removeItem('privacyPolicy')
    }
  });

    e.preventDefault();
    $('.screen2').addClass('hide');
    $('.screen4').removeClass('hide');
    gtag('event', 'screen', {'event_category': 'Screen', 'event_label': 'click', 'value': "screen 4 visible" });
    

      gtag('event', 'add-to-cart', {'event_category': 'Add to Cart', 'event_label': 'click', 'value': "Calculator - Products added to cart" });
      $(".bottles_checkbox").trigger('change');
      var household = parseInt($('input.household').val());
      var pets = parseInt($('input.pets').val());
      var bathroom = parseInt($('input.bathroom').val());
      var cleaning = parseInt($('input.cleaning').val());

      if (cleaning == 0) {
        cleaning = 0.75;
      }

      var month_price;
      var glassmirror, multisurface, bathroom;
      $('.refill_img').hide();

      var glassmirror = Math.ceil((1 + bathroom) * 0.5 * cleaning);
      var bathroom = Math.ceil((1.1 + bathroom) * 0.5 * cleaning);
      var multisurface = Math.ceil((((1.4 + household) * 0.5) + (pets * 0.5)) * cleaning);

      var g, m, b;
      for (g = 1; g <= glassmirror; g++) {
        $('.glassmirror_result .refill_img.' + g).show();
      }
      for (m = 1; m <= multisurface; m++) {
        $('.multisurface_result .refill_img.' + m).show();
      }
      for (b = 1; b <= bathroom; b++) {
        $('.bathroom_result .refill_img.' + b).show();
      }

      $('.tablet_price').text(month_price);
      $('.calculation_addtocart').attr('data-glassmirror-qty', glassmirror);
      $('.calculation_addtocart').attr('data-multisurface-qty', multisurface);
      $('.calculation_addtocart').attr('data-bathroom-qty', bathroom);

      var glass_price = $('.calculation_addtocart').data('glassmirror-price') * glassmirror;
      var multisurface_price = $('.calculation_addtocart').data('multisurface-price') * multisurface;
      var bathroom_price = $('.calculation_addtocart').data('bathroom-price') * bathroom;
      var total_price = $('[data-total-price]').attr('data-total-price');

      $('.calculation_addtocart .total_price').attr('data-total-price', glass_price + multisurface_price + bathroom_price);

      if ($(".bottles_checkbox").prop('checked') == true) {
        let price_value = parseInt(total_price) + parseInt(glass_price) + parseInt(multisurface_price) + parseInt(bathroom_price);

        var per_month_cost = Math.ceil(price_value / 1200) * 100;
        var per_month_cost_formatted = Shopify.formatMoney(per_month_cost, $('body').data('money-format'));
        $('[data-per-month-price]').text(per_month_cost_formatted);

        $('.calculation_addtocart .total_price').text('- ' + Shopify.formatMoney(price_value, $('body').data('money-format')));
      } else {
        let price_value = parseInt(glass_price) + parseInt(multisurface_price) + parseInt(bathroom_price);

        var per_month_cost = Math.ceil(price_value / 1200) * 100;
        var per_month_cost_formatted = Shopify.formatMoney(per_month_cost, $('body').data('money-format'));
        $('[data-per-month-price]').text(per_month_cost_formatted);

        $('.calculation_addtocart .total_price').text('- ' + Shopify.formatMoney(price_value, $('body').data('money-format')));
      }

      var i, j;
      var tab = glassmirror + multisurface + bathroom;
      var drop = tab / 2;
      var drop_string = tab / 2;
      $('.taken_step .impact_bottle_content').html('');
      $('.taken_step .impact_water_content').html('');

      for (i = 1; i <= tab; i++) {
        $('.taken_step .impact_bottle_content').append("<img class='impact_bottle " + i + "' src='//cdn.shopify.com/s/files/1/0566/5567/5591/files/bottle_20x.png?v=2929862286845299494'>");
      }
      for (j = 1; j <= drop; j++) {
        $('.taken_step .impact_water_content').append("<img class='impact_bottle " + j + "' src='https://cdn.shopify.com/s/files/1/0566/5567/5591/files/drop_20x.png?v=1623930924'>");
      }
      if (String(drop).indexOf('.5') > -1) {
        $('.taken_step .impact_water_content').append("<img class='impact_bottle' src='https://cdn.shopify.com/s/files/1/0566/5567/5591/files/half-drop_20x.png?v=1623930471'>");
      }
      gtag('event', 'screen', {'event_category': 'Screen', 'event_label': 'click', 'value': "Add to Cart" });
  });
  
  $(document).on('click', '.screen4 .next', function (e) {
    e.preventDefault();
    $('.screen4').addClass('hide');
    $('.screen5').removeClass('hide');
    gtag('event', 'screen', {'event_category': 'Screen', 'event_label': 'click', 'value': "Product Listing" });
  });
  $(document).on('click', '.screen4 .skip-addtocart', function (e) {
    e.preventDefault();
    $('.screen4').addClass('hide');
    $('.screen5').removeClass('hide').addClass('skip-page');
    gtag('event', 'screen', {'event_category': 'Screen', 'event_label': 'click', 'value': "Final page" });
  });

  //   Back Screen
  $(document).on('click', '.screen2 .back', function (e) {
    e.preventDefault();
    $('.screen2').addClass('hide');
    $('.screen1').removeClass('hide');
    gtag('event', 'screen', {'event_category': 'Screen', 'event_label': 'click', 'value': "screen 1 visible" });
  });
  $(document).on('click', '.screen4 .back', function (e) {
    e.preventDefault();
    $('.screen4').addClass('hide');
    $('.screen2').removeClass('hide');
    gtag('event', 'screen', {'event_category': 'Screen', 'event_label': 'click', 'value': "screen 3 visible" });
  });
  $(document).on('click', '.screen5 .back', function (e) {
    e.preventDefault();
    $('.screen5').addClass('hide').removeClass('skip-page');
    $('.screen4').removeClass('hide');
    gtag('event', 'screen', {'event_category': 'Screen', 'event_label': 'click', 'value': "screen 4 visible" });
  });
  $(document).on('click', '.screen5 .start-over', function (e) {
    e.preventDefault();
    $('.screen5').addClass('hide').removeClass('skip-page');
    $('.screen1').removeClass('hide');
    gtag('event', 'screen', {'event_category': 'Screen', 'event_label': 'click', 'value': "screen 1 visible" });
  });

  $(document).on('input change', '.bottles_checkbox', function () {
    var total_price = $('[data-total-price]').attr('data-total-price');
    if ($(this).prop('checked') == true) {
      var glassbottle_qty = parseInt($("[data-glassmirror-qty]").attr('data-glassmirror-qty'));
      var multisurfacebottle_qty = parseInt($("[data-multisurface-qty]").attr('data-multisurface-qty'));
      var bathroombottle_qty = parseInt($("[data-bathroom-qty]").attr('data-bathroom-qty'));

      var glassbottle_price = $(this).attr('data-glassmirror-bottle-price') * glassbottle_qty;
      var multisurfacebottle_price = $(this).attr('data-multisurface-bottle-price') * multisurfacebottle_qty;
      var bathroombottle_price = $(this).attr('data-bathroom-bottle-price') * bathroombottle_qty;
      var with_bottle_price = parseInt(total_price) + parseInt(glassbottle_price) + parseInt(multisurfacebottle_price) + parseInt(bathroombottle_price);

      var per_month_cost = Math.ceil(with_bottle_price / 1200) * 100;
      var per_month_cost_formatted = Shopify.formatMoney(per_month_cost, $('body').data('money-format'));

      $('[data-per-month-price]').text(per_month_cost_formatted);
      $('.calculation_addtocart .total_price').text('- ' + Shopify.formatMoney(with_bottle_price, $('body').data('money-format')));
    } else {
      var glassbottle_qty = parseInt($("[data-glassmirror-qty]").attr('data-glassmirror-qty'));
      var multisurfacebottle_qty = parseInt($("[data-multisurface-qty]").attr('data-multisurface-qty'));
      var bathroombottle_qty = parseInt($("[data-bathroom-qty]").attr('data-bathroom-qty'));

      var glassbottle_price = $(this).attr('data-glassmirror-bottle-price') * glassbottle_qty;
      var multisurfacebottle_price = $(this).attr('data-multisurface-bottle-price') * multisurfacebottle_qty;
      var bathroombottle_price = $(this).attr('data-bathroom-bottle-price') * bathroombottle_qty;
      var with_bottle_price = parseInt(glassbottle_price) + parseInt(multisurfacebottle_price) + parseInt(bathroombottle_price);

      var per_month_cost = Math.ceil(with_bottle_price / 1200) * 100;
      var per_month_cost_formatted = Shopify.formatMoney(per_month_cost, $('body').data('money-format'));

      $('[data-per-month-price]').text(per_month_cost_formatted);
      $('.calculation_addtocart .total_price').text('- ' + Shopify.formatMoney(with_bottle_price, $('body').data('money-format')));

    }
  });

  $(document).on('click', '.calculation_addtocart', function () {
    var itemsArray = Array();
    var glassmirror_id = $(this).data('glassmirror-id');
    var glassmirror_qty = $(this).data('glassmirror-qty');

    var multisurface_id = $(this).data('multisurface-id');
    var multisurface_qty = $(this).data('multisurface-qty');

    var bathroom_id = $(this).data('bathroom-id');
    var bathroom_qty = $(this).data('bathroom-qty');

    var glass = {
      id: glassmirror_id,
      quantity: glassmirror_qty
    }
    var multisurface = {
      id: multisurface_id,
      quantity: multisurface_qty
    }
    var bathroom = {
      id: bathroom_id,
      quantity: bathroom_qty
    }

    itemsArray.push(glass);
    itemsArray.push(multisurface);
    itemsArray.push(bathroom);

    var bottles = $('.bottles_checkbox').prop('checked');
    if (bottles == true) {
      var id = $("[data-three-bottles-id]").attr('data-three-bottles-id');
      var three_bottles_checked = {
        id: id,
        quantity: 1
      }
      itemsArray.push(three_bottles_checked);
    }

    if (itemsArray.length > 0) {
      $.ajax({
        url: '/cart/add.js',
        method: 'post',
        dataType: 'JSON',
        data: { items: itemsArray },
        success: function (data) {
          $.get('/cart.json', function (data) {
            $('[data-cart-count]').text(data.item_count);
          });
        },
        error: function (error) {
          console.log('error occured');
        }
      });
    }
  });
});

$(document).ready(function () {

  $(".inputs_wrapper").each(function (ix, em) {
    
    $(em).append(`<span class='js-prev-range-2'></span><span class='js-next-range-2'></span>`);
  });

  $(document).on('click', '.js-prev-range', function (e) {
    e.preventDefault();
    let parent_em = $(e.target).parents('.inputs_wrapper');
    let input_em = $(parent_em).find('input[type="range"]');
    let min_value = $(input_em).attr('min');
    let step_value = $(input_em).attr('step');
    let current_value = $(input_em).val();
    let new_value = parseInt(current_value) - parseInt(step_value);
    if (new_value < min_value) {
      new_value = min_value;
    }
    $(input_em).val(new_value).trigger('change');
  });

  $(document).on('click', '.js-next-range', function (e) {
    e.preventDefault();
    let parent_em = $(e.target).parents('.inputs_wrapper');
    let input_em = $(parent_em).find('input[type="range"]');
    let max_value = $(input_em).attr('max');
    let step_value = $(input_em).attr('step');
    let current_value = $(input_em).val();
    let new_value = parseInt(current_value) + parseInt(step_value);
    if (new_value > max_value) {
      new_value = max_value;
    }
    $(input_em).val(new_value).trigger('change');
  });
  if ( $('.accordion').length ) {
    $('.faq-simple .accordion li:first-child, .variable_products .accordion li:first-child').addClass('active');
    $('.faq-simple .accordion li:first-child .inner, .variable_products li:first-child .inner').addClass('show').slideDown(0);
    $('.accordion .toggle').click(function (e) {
      e.preventDefault();
      $(this).parent().siblings().removeClass('active');
      $(this).parent().toggleClass('active');
  
      let $this = $(this);
  
      if ($this.next().hasClass('show')) {
        $this.next().removeClass('show');
        $this.next().slideUp(350);
      } else {
        $this.parent().parent().find('li .inner').removeClass('show');
        $this.parent().parent().find('li .inner').slideUp(350);
        $this.next().toggleClass('show');
        $this.next().slideToggle(350);
      }
    });
  }
});


/********************* Atmo tv video load more js start **********************/

$(document).ready(function () {
  $(".product_column").slice(0, 6).show();
  $(window).trigger('resize');
  $("body").on('click touchstart', '#loadMore', function (e) {
    e.preventDefault();
    $(".product_column:hidden").slice(0, 3).slideDown();
    if ($(".product_column:hidden").length == 0) {
      $("#loadMore").css('visibility', 'hidden');
    }
    $(".video--main-js").masonry();
  });
});


/********************* Atmo tv video load more js end **********************/
function equalHeight(group) {
  //group.css('height','auto'); 
  var tallest = 0;
  group.each(function() {
    var thisHeight = $(this).height();
    if(thisHeight > tallest) {
      tallest = thisHeight;
    }
  });
  group.height(tallest);
}
$(document).ready(function () {
  var arrowDot = $('.arrow-dot');
  
  $(arrowDot).on('click', function (event) {
      event.preventDefault();
      if( $(this).hasClass('active')) {
        $(this).find('.arrow__icon').html('+');
        $(arrowDot).removeClass('active');
        $(".the_science__tab").hide();
        $(".the_science__tab").attr('aria-hidden', true);
        $(".the_science__tab").css('display', 'none');
      } else {
        $(arrowDot).removeClass('active');
        $('.arrow__icon').html('+');
        $(".the_science__tab").hide();
        $(this).addClass('active');
        $(this).find('.arrow__icon').html('×');
        
        var currentTab = 'tab-' + $(this).attr('id');
        var tab = $(".science_hero__container").find("[data-name='" + currentTab + "']"); 
        tab.show();
        tab.attr('aria-hidden', false);    
      }
  });
  $(document).on('click', '.ajax_cart_popup', function (e) {
    console.log('add3 js');
    e.preventDefault();
    var target = e.target;
    var data_id = $(target).attr("data-id");
    var quantity = 1;
    $.ajax({
      url: "/cart/add.js",
      data: { id: data_id, quantity: quantity },
      method: "POST",
      dataType: "JSON",
      success: function (data) {
        window.location = "/cart";
      },
      error: function (data) {
        console.log(data);
      }
    });
  });

  window.setTimeout(function(){
    $("#__3__7").prop('checked',true)
  },2500);

  $('.readmore').click(function (event) {
    event.preventDefault();
    var descriptionFull = document.querySelector('.product-description-full');
    descriptionFull.style.display = 'block';
    var descriptionShortMobile = document.querySelector('.product-description-short.hidden-desktop');
    var descriptionShortDesktop = document.querySelector('.product-description-short.hidden-mobile');
    descriptionShortMobile.style.display = 'none';
    descriptionShortDesktop.style.display = 'none';
  });
  $('.readless').click(function (event) {
    event.preventDefault();
    var descriptionFull = document.querySelector('.product-description-full');
    descriptionFull.style.display = 'none';
    var descriptionShortMobile = document.querySelector('.product-description-short.hidden-desktop');
    var descriptionShortDesktop = document.querySelector('.product-description-short.hidden-mobile');
    descriptionShortMobile.style.display = 'block';
    descriptionShortDesktop.style.display = 'block';
  });
  var offset = 220;
  var duration = 500;
  jQuery(window).scroll(function() {
    if (jQuery(this).scrollTop() > offset) {
      jQuery('.back-to-top').fadeIn(duration);
    } else {
      jQuery('.back-to-top').fadeOut(duration);
    }
    if ( jQuery(this).scrollTop() > 850 && jQuery(window).scrollTop() + jQuery(window).height() < jQuery(document).height() - 950 ) {
      jQuery('.product-area__add-to-cart-xs').removeClass('v-hidden');
      jQuery('.back-to-top').addClass('sticky-addtocart');
    } else {
      jQuery('.product-area__add-to-cart-xs').addClass('v-hidden');
      jQuery('.back-to-top').removeClass('sticky-addtocart');
    }
  });

  jQuery('.back-to-top').click(function(event) {
    event.preventDefault();
    jQuery('html, body').animate({scrollTop: 0}, duration);
    return false;
  })
  $('.quantity-wrapper input, .quantity-wrapper [data-quantity]').on('click', function(e){
    var id = $(this).parents('.quantity-wrapper').find('input').attr("data-id");
    var price = parseInt($(this).parents('.quantity-wrapper').find('input').attr("data-price"));
    var qty_val = parseInt($(this).parents('.quantity-wrapper').find('input').val());
    if ( $(this).data('quantity') == 'up' ) {
      qty_val = qty_val + 1;
    } else {
      qty_val = qty_val - 1;
    }
    if ( qty_val > 0 ) {
      var subTotal = price * qty_val
      var item_total_price = Shopify.formatMoney(subTotal, $('body').data('money-format'));
      $(this).parents('.qty-price').find('.price-area .current-price').text(item_total_price);
    }
  });
  
  if (window.matchMedia("(max-width: 767px)").matches) {
    $('.item-image.image-three').insertAfter('.left .item-image.image-one');
  }
  var checkForYotpoPagination;
  var runScript = function(){
    checkForYotpoPagination = setInterval(function(){
      if($('.yotpo [role="navigation"] .yotpo-pager').length > 0){
        clearTimeout(checkForYotpoPagination);
        var get_current_page = parseInt($(this).attr('data-current-page'));
        var total_reviews = parseInt($('.yotpo [role="navigation"] .yotpo-pager').attr('data-total'));
        var review_per_page = parseInt($('.yotpo [role="navigation"] .yotpo-pager').attr('data-per-page'));
        var total_pages = total_reviews/review_per_page;
        $('#more-reviews').attr('data-total-pages', Math.ceil(total_pages));
        if ( get_current_page != total_pages ) {
          $('.more-reviews').removeClass('hide');
        }
        return false;
      } 
    },1000);
  };
  runScript(); 
  $('#more-reviews').on('click', function(e) {
    e.preventDefault();
    var $this =$(this),
        get_next_page = parseInt($(this).attr('data-current-page')) + 1,
    	get_total_pages = parseInt($(this).attr('data-total-pages'));
    $this.siblings('[loader]').removeClass('hide');
    $this.siblings('svg').hide();
    $this.hide();
    var data = 
        {
          "methods": [
            {
              "method":"main_widget",
              "params": {
                "pid": "6727309721799",
                "page": get_next_page
              }
            },
            {
              "method":"bottomline",
              "params": {
                "pid": "6727309721799"
              },
              "format": "json"
            }
          ],
          "app_key":"yT8qcd6jYQxuuNq1JZCCdDo0fEi1LgxQ5yBXKDBn"
        };
    $.ajax({
      url: 'http://staticw2.yotpo.com/batch',
      type: 'POST',
      data: JSON.stringify(data),
      contentType: "application/json",
      dataType: 'json',
      success: function(responseHTML){
        console.log('test ', responseHTML);
        var get_response_html = responseHTML[0].result;
        $this.attr('data-current-page', get_next_page);
        if ( !$(get_response_html).hasClass('yotpo-no-reviews') ) {
          $('.yotpo-reviews.yotpo-active').append($(get_response_html).find('.yotpo-reviews.yotpo-active').html());
          $this.siblings('[loader]').addClass('hide');
          $this.show();
        }
      },
      complete: function() {
        if(get_next_page >= get_total_pages) {
          $this.parents('.more-reviews').hide();
        } 
      }
    });
  });
  
  if ( $('.thumbnails .product__image-thumbnail').length ) {
    $('.thumbnails .product__image-thumbnail').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      vertical: true,
      verticalSwiping: true,
      asNavFor: '.product-photos',
      focusOnSelect: true
    });
  }
  var zoomOptions = {cursor: 'crosshair',easing: true,scrollZoom: true};
  if ( $('.product-photos').length ) {
    $('.product-photos').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      adaptiveHeight: true,
      nextArrow: '<div class="custom-arrow right"><svg fill="#444" class="arrow--right js-next-range"  id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 106.47 181.65"><defs></defs><g id="SvgjsG1008"><path class="cls-1" d="M111.41,49.66a12.53,12.53,0,0,1-3.75,9.07L26.27,137a12.76,12.76,0,0,1-17.85-.31c-4.69-5-4.69-13.15.32-17.84l72-69.18-72-69.19a12.76,12.76,0,0,1-.32-17.84,12.76,12.76,0,0,1,17.85-.31l81.39,78.26a12.53,12.53,0,0,1,3.75,9.08Z" transform="translate(-4.94 41.17)"/></g><path class="cls-1" d="M21.64,64" transform="translate(-4.94 41.17)"/><path class="cls-1" d="M93.64-5.18" transform="translate(-4.94 41.17)"/></svg></div>',
      prevArrow: '<div class="custom-arrow left"><svg class="arrow--left js-prev-range" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 106.47 181.65"><defs></defs><g id="SvgjsG1008"><path class="cls-1" d="M4.94,49.66A12.5,12.5,0,0,1,8.7,40.58L90.09-37.68a12.75,12.75,0,0,1,17.84.31,12.75,12.75,0,0,1-.31,17.84l-72,69.19,72,69.18c5,4.69,5,12.83.31,17.84s-12.83,5-17.84.31L8.7,58.73a12.5,12.5,0,0,1-3.76-9.07Z" transform="translate(-4.94 41.17)"/></g><path class="cls-1" d="M21.64,64" transform="translate(-4.94 41.17)"/><path class="cls-1" d="M93.64-5.18" transform="translate(-4.94 41.17)"/></svg></div>',
      asNavFor: '.product__image-thumbnail',
      responsive: [
        {
          breakpoint: 767,
          settings: {
            arrows: false,
            adaptiveHeight: true
          }
        }
      ]
    });
  }
  // $(".product-photos .slick-current img").elevateZoom(zoomOptions);
  // $(".product-photos").on("beforeChange", function(event, slick, currentSlide, nextSlide) {
  //   $.removeData(currentSlide, "elevateZoom");
  //   $(".zoomContainer").remove();
  // });
  // $(".product-photos").on("afterChange", function() {
  //   $(".product-photos .slick-current img").elevateZoom(zoomOptions);
  // });
  if ( $('.testimonial-slider').length ) {
    $('.testimonial-slider').not('.slick-initialized').slick({
      infinite: true,
      arrows: true,
      dots: false,
      slidesToShow: 2.99,
      slidesToScroll: 1,
      nextArrow: '<div class="swiper-button-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"> <path d="M0-.25H24v24H0Z" transform="translate(0 0.25)" style="fill:none"></path> <polyline points="10 17.83 15.4 12.43 10 7.03" style="fill:none;stroke:currentColor;stroke-linecap:round;stroke-miterlimit:8;stroke-width:3px"></polyline> </svg></div>',
      prevArrow: '<div class="swiper-button-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"> <path d="M0-.25H24v24H0Z" transform="translate(0 0.25)" style="fill:none"></path> <polyline points="14.4 7.03 9 12.43 14.4 17.83" style="fill:none;stroke:currentColor;stroke-linecap:round;stroke-miterlimit:8;stroke-width:3px"></polyline> </svg></div>',
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
  if ( $('.top-slider-main').length ) {
    $('.top-slider-main').not('.slick-initialized').slick({
      slidesToScroll: 1,
      fade: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 5000,
      infinite: true
    });
  }
  if ( $('.popup-icon').length ) {
    $('.popup-icon').on('click', function (event) {
      event.preventDefault();
      $(this).toggleClass('active');
      var currentTab = $(this).attr('id');
      var tab = $(".popup-small[data-name='" + currentTab + "']");
      tab.toggle();
    });
    $('.popup-close-icon').on('click', function (event) {
      event.preventDefault();
      var currentTab = $(this).attr('data-popup-small');
      var tab = $(".popup-small[data-name='" + currentTab + "']");
      $('#'+currentTab).removeClass('active');
      tab.hide();
    });
  }
  var maxHeight = 0;
  $(".section-text-columns-with-images .h3-sub").each(function(){
    if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
  });
  $(".section-text-columns-with-images .h3-sub").height(maxHeight);
  if (window.matchMedia("(min-width: 768px)").matches) {
    if ( $(".announcement-slider").length > 1 ) {
      $(".announcement-slider").slick({
        arrows: false,
        autoplay: true,
        infinite: true,
        vertical: true,
        draggable: false,
        autoplaySpeed: 6000
      });
    }
  }
  $('ul.clickyboxes a').on('click', function() {
    var get_variant_price = $( '.original-selector option:selected' ).attr('data-price');
//     $('.product-detail__form__action .theme-money.price').text(Shopify.formatMoney(get_variant_price, $('body').data('money-format')));
  });
  if ( $('.product-swiper-container').length) {
    var swiper = new Swiper(".product-swiper-container", {
      slidesPerView: 3,
      spaceBetween: 70,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: !0
      },
      breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween: 20,
        }
      },
      on: {
        init: function () {
          $('.product-swiper-container').addClass('swiper-initialized');
        }
      }
    });
  }
  var checkExist = setInterval(function() {
    if ( $('.product-recommendation-swiper').length) {
        var swiper = new Swiper(".product-recommendation-swiper", {
          slidesPerView: 4,
          spaceBetween: 70,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          scrollbar: {
            el: ".swiper-scrollbar",
            draggable: !0
          },
          breakpoints: {
            640: {
              slidesPerView: 1,
              spaceBetween: 20,
            }
          },
          on: {
            init: function () {
              $('.product-recommendation-swiper').addClass('swiper-initialized');
            }
          }
      });
      clearInterval(checkExist);
    }
  }, 100);
  // BEGIN KLAVIYO SIGNUP FORM CODE
  KlaviyoSubscribe.attachToForms('#email_signup', {
    hide_form_on_success: true,
    success_message: "Thank you! Please check your email to activate your subscription."
  });
  KlaviyoSubscribe.attachToForms('#email_signup_popup', {
    hide_form_on_success: true,
    success_message: "Thank you! Please check your email to activate your subscription."
  });
  KlaviyoSubscribe.attachToForms('#calc_email_signup', {
    hide_form_on_success: true,
    success_message: "Thank you! Please check your email to activate your subscription."
  });
  var _learnq = window._learnq || [];
  KlaviyoSubscribe.attachToForms('#quiz_signup', {
    hide_form_on_success: true,
    custom_success_message: true,
    extra_properties: {
      $source: 'Custom Quiz',
      $method_type: "Klaviyo Form",
      $method_id: 'embed',
      $consent_version: 'Quiz Embed default text'
    },
    success: function ($form) {
      var get_email = $('#klaviyo_customer_email').val();
      const settings = {
        async: true,
        crossDomain: true,
        url: 'https://a.klaviyo.com/api/track',
        method: 'POST',
        headers: {
          accept: 'text/html',
          'content-type': 'application/x-www-form-urlencoded'
        },
        data: {
          data: '{"token": "UHC7uj", "event": "Quiz Custom Event", "customer_properties": {"$email": "'+get_email+'"}}'
        }
      };
      $.ajax(settings).done(function (response) {
        console.log('Success', response);
      });
      // _learnq.push(['track', 'Quiz Custom Event']);
      console.log('EN Klaviyo Quiz Custom Event Triggered'); 
      // if ( $(body).hasClass('language-en') ) {
      //   console.log('EN Klaviyo Quiz Custom Event Triggered'); 
      //   _learnq.push(['track', 'Quiz Custom Event']);
      // } else if ( $(body).hasClass('language-de') ) {
      //   console.log('DE Klaviyo Quiz Custom Event Triggered');
      //   _learnq.push(['track', 'Quiz Custom Event DE']);
      // } else if ( $(body).hasClass('language-fr') ) {
      //   console.log('FR Klaviyo Quiz Custom Event Triggered');
      //   _learnq.push(['track', 'Quiz Custom Event FR']);
      // }
      var email = $form.find('[name="email"]').val();
      $('.klaviyo-quiz-popup .form-section').addClass('hidden');
      $('.klaviyo-quiz-popup .klaviyo_messages .success_message').removeClass('hidden');
    }
  });
  // END  KLAVIYO SIGNUP FORM CODE
  const product_lists = document.querySelectorAll('.dropdown-inner .product-list');
  const link_hover_item = document.querySelectorAll('.dropdown-inner .link-list > li');
  var toggleDropdownClasses = function() {	
    var get_collection_id = this.getAttribute('data-collection-id');	
    product_lists.forEach(node => node.classList.remove('active'));	
    link_hover_item.forEach(node => node.classList.remove('active'));	
    this.classList.add('active');	
    [...product_lists].filter(product_list => product_list.dataset.collectionId === get_collection_id)[0].classList.add('active');	
  };
  Array.from(link_hover_item).forEach(function(element) {
    element.addEventListener('mouseover', toggleDropdownClasses);
  });
  $('.nav-row > .tier-1 > ul > li > .dropdown-menu').on('mouseleave', function() {
    $('.link-list li').first().addClass('active').siblings().removeClass('active');
    $('.dropdown-inner > .product-list').first().addClass('active').siblings().removeClass('active');
  });
  equalHeight($('.text-img-items .h4'));
});
function sendEvent(el) {
  console.log('testt2', $(el).val());
  $('#klaviyo_customer_email').val($(el).val());
}
//  jQuery('.next').click(function(e) {
//         var jump = jQuery(this).attr('href');
//         var new_position = jQuery(jump).offset();
//         var scroll = -85;
//         jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 800, function(){
//             var new_position = jQuery(jump).offset();
//             jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 800);
//         });
//         e.preventDefault();
//     });


//  jQuery('.Button__FormStyledButton-p2mbjt-0.kKZyAu.kl-private-reset-css-Xuajs1').click(function(e) {
//         var jump = jQuery(this);
//         var new_position = jQuery(jump).offset();
//         var scroll = 0;
//         jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 400, function(){
//             var new_position = jQuery(jump).offset();
//             jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 800);
//         });
//         e.preventDefault();
//     });
$(document).ready(function () {
  var check_exist = [];
  
  // Function to update totals
  function updateTotals() {
    var totalDiscountedPrice = 0;
    var totalOldPrice = 0;

    $('.bundle-item-list').each(function () {
      var itemPrice = parseFloat($(this).attr('data-product-price'));
      var originalPrice = parseFloat($(this).attr('data-original-price'));

      if (!isNaN(itemPrice) && itemPrice.length !== 0) {
        totalDiscountedPrice += itemPrice;
      }

      if (!isNaN(originalPrice) && originalPrice.length !== 0) {
        totalOldPrice += originalPrice;
      }
    });

    // Update the total in the HTML
    $('.sub-total .final-price').html('$' + totalDiscountedPrice.toFixed(2));
    $('.sub-total .old-price').html('$' + totalOldPrice.toFixed(2));

    var filledItemCount = $('.bundle-boxes .bundle-box-item.active').length;

    // Enable/disable the "Add Gift set to cart" button
    var $addtocartButton = $('#bundle-addtocart');
    if (filledItemCount >= 3) {
      $addtocartButton.removeClass('disabled');
    } else {
      $addtocartButton.addClass('disabled');
    }
  }

  // Event handler for adding items
  $(document).on('click', '.custom-bundle-addtocart', function () {
    var item_id = $(this).closest('.product-block').find('input[name="productDetails"]').attr('data-variant-id');
    var product_title = $(this).closest('.product-block').find('input[name="productDetails"]').attr('data-product-title');
    var product_price = parseFloat($(this).closest('.product-block').find('input[name="productDetails"]').attr('data-product-price'));
    var product_discount = parseFloat($(this).closest('.product-block').find('input[name="productDetails"]').attr('data-product-discount'));
    var image_url = $(this).closest('.product-block').find('input[name="productDetails"]').attr('data-product-image');
    var updated_item_id;
    let random_item_id = Math.random().toString(36).substring(4);

    if (jQuery.inArray(item_id, check_exist) != -1) {
      updated_item_id = item_id + '_' + random_item_id;
    } else {
      updated_item_id = item_id;
    }

    check_exist.push(item_id);

    var discounted_price = product_price - (product_price * (product_discount / 100));

    var bundle_list_html = '<div class="bundle-item-list item--' + updated_item_id + '" data-variant-id="' + item_id + '" data-product-price="' + discounted_price.toFixed(2) + '" data-product-discount="' + product_discount + '" data-original-price="' + product_price.toFixed(2) + '">\
                          <div id="' + updated_item_id + '" class="close-container" data-id="' + item_id + '" data-price="' + discounted_price.toFixed(2) + '"><svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"> <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/> <path d="M0 0h24v24H0z" fill="none"/> </svg></div>\
                          <div class="image"><img src="' + image_url + '" /></div>\
                          <div class="title ff-granville">'+product_title+'</div>\
                          </div>';

    $('.bundle-boxes .bundle-box-item').each(function (i, val) {
      if ($(this).hasClass('empty')) {
        $(this).removeClass('empty').addClass('active');
        $(this).append(bundle_list_html);
        return false; // Exit the loop after finding the first empty box
      }
    });

    updateTotals();
  });

  // Event handler for removing items
  $(document).on('click', '.close-container', function () {
    var $bundleItem = $(this).closest('.bundle-item-list');
    var $bundleBoxes = $bundleItem.closest('.bundle-boxes');
    var index = $bundleBoxes.find('.bundle-box-item').index($bundleItem.parent());
  
    $bundleItem.remove();
    $bundleBoxes.find('.bundle-box-item').eq(index).removeClass('active').addClass('empty');
    updateTotals();
  });
  $(document).on("click", "#bundle-addtocart:not(.disabled)", function (e) {
    e.preventDefault();
    var get_data = { items: [] };
    var addtocart_form = $('[action="/cart/add"]');
      $.each($(".bundle-boxes .bundle-item-list"), function(){
        get_data.items.push({
          quantity: 1,
          id: $(this).attr('data-variant-id')
        });
      });
      if( get_data.items.length >= 1 ) {
        $(this).find('.txt').hide().siblings('.loader').removeClass('hide');
        return $.ajax({
          url: '/cart/add.js',
          dataType: 'json',
          type: 'post',
          data: get_data,
          success: function(data) {
            setTimeout(function(){
              $('.bundle-selection-footer').find('.txt').show().siblings('.loader').addClass('hide');
              window.mini_cart.updateCart();
              window.mini_cart.updateRefillPopup();
              // window.location.href = '/cart' 
              }, 1500);
          },
          error: function(xhr, textStatus, errorThrown) {
            var data = xhr.responseJSON;
            $('.error-msg').addClass('error').html('<span><b>ERROR: </b>' + data.description);
          }
        });
      }
  });
  if ( $('.bundle-box .short-desc').length ) {
    equalHeight($('.bundle-box .short-desc'));
  }
  if ( $('.bundle-box .content-header').length ) {
    equalHeight($('.bundle-box .content-header'));
  }
  if ( $('#gift-popup-main .cc-popup-close').length ) {
    $('#gift-popup-main .cc-popup-close').on('click', function() {
      $('#gift-popup-main').removeClass('cc-popup--visible');  
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.clickyboxes').forEach($optCont => {
    // Add active class on page load
    const $select = document.querySelector(`#product_form_${$optCont.id.replace('clickyboxes-', '')} .original-selector`);
    const $preorderText = document.querySelector('.preorder-text'); // Preorder text element
    const $preorderBtn = document.querySelector('.preorder-btn');   // Preorder button element

    if ($select) {
      const selectedValue = $select.value;
      const activeOption = $optCont.querySelector(`a[data-value="${selectedValue}"]`);
      if (activeOption) {
        activeOption.classList.add('active');
        // Update preorder text and button on page load
        updatePreorderUI(activeOption, $preorderText, $preorderBtn);
      }
    }

    // Handle click events
    $optCont.addEventListener('click', event => {
      const target = event.target.closest('a');

      if (target) {
        event.preventDefault();

        if (!target.classList.contains('active')) {
          const $clicky = target.closest('.clickyboxes');
          const $select = document.querySelector(`#product_form_${$clicky.id.replace('clickyboxes-', '')} .original-selector`);

          if ($select) {
            // Update the select dropdown with the selected value
            $select.value = target.dataset.value;
            $select.dispatchEvent(new Event('change'));

            // Update active class
            $clicky.querySelectorAll('a').forEach(link => link.classList.remove('active'));
            target.classList.add('active');

            // Update preorder text and button
            updatePreorderUI(target, $preorderText, $preorderBtn);
          }
        }
      }
    });
  });

  // Function to update preorder text and button
  function updatePreorderUI(option, preorderText, preorderBtn) {
    if (option.getAttribute('data-preorder') === 'true') {
      if (preorderText) {
        preorderText.classList.remove('hide');
      }
      if (preorderBtn) {
        preorderBtn.textContent = 'Pre Order Now';
        preorderBtn.setAttribute('aria-label', 'Pre Order Now'); // Update aria-label
        theme.strings.buttonDefault = 'Pre Order Now';
      }
    } else {
      if (preorderText) {
        preorderText.classList.add('hide');
      }
      if (preorderBtn) {
        preorderBtn.textContent = 'Add to Cart';
        preorderBtn.setAttribute('aria-label', 'Add to Cart'); // Update aria-label
        theme.strings.buttonDefault = 'Add to Cart';
      }
    }
  }
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-block').forEach((productBlock) => {

    // Get variant data
    const variants = JSON.parse(
      productBlock.querySelector('.variant-data').textContent
    );

    productBlock.querySelectorAll('.variant-option-radio').forEach((swatch) => {
      swatch.addEventListener('change', (event) => {

        console.log('testtttttt');

        const productId = event.target.dataset.productId;
        const variantId = parseInt(event.target.value);

        const variant = variants.find(v => v.id === variantId);

        const variantInput = productBlock.querySelector(
          `#product_form_${productId} input[name="id"]`
        );

        if (variantInput) {
          variantInput.value = variantId;
        }

        const addToCartText = productBlock.querySelector('.final-atc-button .addtocart_text');

        if (!variant) return;

        // 🔥 Inventory Check
        if (!variant.available || variant.inventory_quantity <= 0) {

          addToCartText.textContent = "Out of Stock";

          productBlock.querySelector('.final-atc-button').disabled = true;

        } else {
          const isPreOrder = event.target.dataset.preorder === "true";

          addToCartText.textContent = isPreOrder
            ? "Pre Order Now"
            : "Add to Cart";

          productBlock.querySelector('.final-atc-button').disabled = false;
        }

      });
    });
  });
});